import { IonButton, IonItem } from "@ionic/react";
import { SchoolModel } from "model";
import { Link } from "react-router-dom";
import { Card, Colors, Icon } from "swing-components";

import { translate } from "~utils";

type SchoolCardProps = {
  school: SchoolModel;
};

export function SchoolCard(props: SchoolCardProps) {
  const { school } = props;

  return (
    <li
      css={{
        padding: 0,
        width: "100%",
        listStyle: "none",
      }}
    >
      <Card>
        <IonItem className="ion-no-padding">
          <div className="p-4 flex w-full items-center gap-4">
            <Icon name="School" />
            <span className="font-medium">{school?.name}</span>
          </div>
        </IonItem>
        <IonItem className="ion-no-padding">
          <div className="p-4 flex gap-4">
            <Icon name="Location" />
            <div>
              <p css={{ margin: 0 }}>{school?.streetAddress}</p>
              {school?.city.length > 0 ? `${school.city}, ` : undefined}
              {school?.state.length > 0 ? `${school.state} ` : undefined}
              {school?.zip.length > 0 ? school?.zip : undefined}
            </div>
          </div>
        </IonItem>
        <div
          css={{
            display: "flex",
            padding: 8,
            paddingBottom: 0,
            justifyContent: "center",
          }}
        >
          <Link to={`/schools/${school.id}`}>
            <IonButton fill="clear">
              <div className="flex items-center justify-center gap-2">
                <Icon name="Eye On" color={Colors.blue500} />
                {translate("LABEL_VIEW")}
              </div>
            </IonButton>
          </Link>
        </div>
      </Card>
    </li>
  );
}
